import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {CustomFormControl} from '../CustomFormControl';
import {SplitterType} from '../../../directives/number-splitter.directive';
import {FormHelperService} from '../../../services/form-helper.service';
import {FileOnlineViewModel} from '../../../FileOnlineViewModel';

@Component({
    selector: 'app-dynamic-control',
    templateUrl: './dynamic-control.component.html',
    styleUrls: ['./dynamic-control.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DynamicControlComponent implements OnInit {

  @Input() formGroup!: UntypedFormGroup;
  @Input() control!: CustomFormControl;
  @Input() viewModel: FileOnlineViewModel;
  @Input() arrayIndex!: number;
  @Input() controlCache!: Map<string, CustomFormControl>;
  protected readonly SplitterType = SplitterType;

  constructor(protected formHelper: FormHelperService) { }

  ngOnInit(): void {
  }

  getTooltip(control: CustomFormControl): string {
    if (control.element.isProfileField === true) {
      return 'Change this under My Account > Profile';
    }

    if (control.element.tooltip) {
      return control.element.tooltip;
    }

    return undefined;
  }

}
